export default {
  connected() {
    this.todoSyncTimers = {};
  },

  syncTodo(todoGuid, todoItem) {
    this.stopSyncTodo(todoGuid);

    const editing = !!this.querySelector(
      `tr-todo-item-plus[data-guid="${todoGuid}"][editing]`,
    );

    if (editing) {
      this.todoSyncTimers[todoGuid] = setTimeout(() => {
        this.syncTodo(todoGuid, todoItem);
      }, 1000);
    } else {
      this.updateTodoItems(todoGuid, todoItem);
    }
  },

  stopSyncTodo(todoGuid) {
    const timer = this.todoSyncTimers[todoGuid];
    if (timer) {
      clearTimeout(timer);
      delete this.todoSyncTimers[todoGuid];
    }
  },

  clearTodoSyncTimers() {
    Object.keys(this.todoSyncTimers).forEach((todoGuid) => {
      this.stopSyncTodo(todoGuid);
    });
  },

  disconnected() {
    this.clearTodoSyncTimers();
  },
};
